import React from 'react';
import { Link } from 'react-router-dom';

const ReturnPolicy = () => {
  const headingStyle = {
    fontSize: '3rem',
    fontWeight: '500',
    // marginTop: '20px',
    marginBottom: '10px',
    color:'#44413e'
  };
  const headingStyle2 = {
    fontSize: '2.1rem',
    fontWeight: '500',
    marginTop: '20px',
    marginBottom: '10px',
    color:'#44413e'
  };

  const textStyle = {
    // fontSize: '16px',
    lineHeight: '1.6',
    marginBottom: '10px'
  };

  const bulletStyle = {
    // fontSize: '16px',
    lineHeight: '1.6',
    marginBottom: '8px',
    paddingLeft: '20px',
    listStyle:'disc'
  };

  return (
    <div style={{padding: '2rem', lineHeight: '1.8', maxWidth: '900px', margin: '0 auto', marginTop:'10rem' }}>
      <div style={headingStyle}>Return Policy</div>

      <div style={headingStyle2}>Can I change my order once it has been placed?</div>
      <div style={textStyle}>
        We don’t accept changes in the order once they are placed. However, if changes are communicated within 24 hours, we might be able to make the change in the order or the address of delivery. These changes are at the sole discretion of Kidorise.
      </div>

      <div style={headingStyle2}>Can I cancel my order?</div>
      <div style={textStyle}>
        Orders can be cancelled within 2 Hours of placing the order. To cancel your order, please send us an email at <Link to="/"style={{textTransform:'none'}}>kidorise9@gmail.com</Link> or call us on <strong>+91 9953110193</strong> with your name, order number, order date, and your mobile number. Our team will call you and confirm the cancellation.
      </div>

      <div style={headingStyle2}>When and how will I get my refund in case of order cancellation?</div>
      <div style={textStyle}>
        Refunds are credited back to the same mode of payment which was debited. The process generally takes 7–14 working days depending on the bank and the gateway. Kidorise does not have influence on the timelines except processing the refund.
        The refund will be credited back between 7–14 working days after the processing or until your next billing cycle in case it’s a credit card.
        You will receive email intimation from us about the processing of refund. You will need to then contact your bank or credit card issuer for refund status.
      </div>

      <div style={headingStyle2}>What is your exchange policy?</div>
      <div style={textStyle}>
        Once products are delivered to you as per the original order, there is no refund or exchange possible. In case there is a manufacturing defect, then the product can be exchanged.
        In case of a manufacturing defect, please contact customer service within 48 hours from the time the product(s) has been delivered to you.
      </div>

      <ul style={{ marginLeft: '20px', paddingLeft: '10px' }}>
        <li style={bulletStyle}>
          Kindly make an unboxing video/click pictures while receiving the order, for raising any dispute-related query like missing items or damaged products.
        </li>
        <li style={bulletStyle}>
          Any concern related to the package should be raised/highlighted within 24–48 hours of the delivery.
        </li>
        <li style={bulletStyle}>
          Products ordered from the Kidorise website are shipped in standard packaging boxes with the brand name and tape on them. Accept the orders only after verifying the same at your end.
        </li>
        <li style={bulletStyle}>
          Tampered packages should be rejected at the time of delivery. If accepted, no complaint will be registered for any issue.
        </li>
      </ul>

      <div style={headingStyle2}>What if products ordered by me are out of stock?</div>
      <div style={textStyle}>
        All products shown on the web store are considered in stock. In an exceptional case where the product ordered by you is out of stock, the same will be communicated within 72 hours and a refund will be processed immediately if you wish to cancel the order.
      </div>
    </div>
  );
};

export default ReturnPolicy;
